import { jsxs as f, jsx as o } from "react/jsx-runtime";
import { Tabs as h, Theme as w, TabLayout as z, TabDesign as V } from "@nextgen-web-framework/all";
import { useState as _, useEffect as b } from "react";
import C from "./TimelineCard/TimelineCard.js";
import '../../assets/AwardsAndAccoladesTimelines.css';const k = "#ffffff", u = "#396e75", B = "#e5fdff", T = "#546223", O = "#f0fae5", R = "#a65523", x = "#fff1e8", y = "#7f3e3e", A = "#ffe2e2", G = "#62625a", W = "#f8f8e7", v = "#38539a", N = "#707070", P = "#c8f8d1", I = "#87c9c8", L = "#5291b1", S = "rgba(82, 145, 177, 0.1019607843)", Y = "#445685", $ = "#181d61", E = "rgba(24, 29, 97, 0.1019607843)", j = "#5969d6", p = "#ea999d", H = "#b6577e", U = "rgba(182, 87, 126, 0.1019607843)", Z = "#7e3e80", q = "#1e247f", F = "rgba(30, 36, 127, 0.1019607843)", J = "#da7600", K = "#107f47", M = "#d91734", Q = "_html_hlbw9_38", m = {
  amwayWhite: k,
  darkBlue: u,
  lightBlue: B,
  darkGreen: T,
  lightGreen: O,
  darkOrange: R,
  lightOrange: x,
  darkRed: y,
  lightRed: A,
  darkYellow: G,
  lightYellow: W,
  darkPurple: v,
  darkGrayOnWhite: N,
  dataVizColor1: P,
  dataVizColor2: I,
  dataVizColor3: L,
  dataVizColor3Background: S,
  dataVizColor4: Y,
  dataVizColor5: $,
  dataVizColor5Background: E,
  dataVizColor6: j,
  dataVizColor7: p,
  dataVizColor8: H,
  dataVizColor8Background: U,
  dataVizColor9: Z,
  dataVizColor10: q,
  dataVizColor10Background: F,
  dataVizAlertOrange: J,
  dataVizSuccessGreen: K,
  dataVizWarningRed: M,
  "no-visible": "_no-visible_hlbw9_34",
  html: Q,
  "awards-timelines-tabs-item-wrapper": "_awards-timelines-tabs-item-wrapper_hlbw9_143",
  "awards-timelines-item-leftsection-image-wrapper": "_awards-timelines-item-leftsection-image-wrapper_hlbw9_156",
  "awards-timelines-item-leftsection-image": "_awards-timelines-item-leftsection-image_hlbw9_156",
  "awards-timelines-container": "_awards-timelines-container_hlbw9_166",
  "awards-timelines-item-rightsection": "_awards-timelines-item-rightsection_hlbw9_178",
  "awards-timelines-item-title": "_awards-timelines-item-title_hlbw9_181",
  "awards-timelines-item-description": "_awards-timelines-item-description_hlbw9_189",
  "awards-timelines-tabs-scroller": "_awards-timelines-tabs-scroller_hlbw9_225"
}, { PURPLE: X } = w, { HORIZONTAL: D } = z, { TRANSPARENT: tt } = V, lt = (e) => {
  var d;
  const { year: g, timelines: a } = e, i = a == null ? void 0 : a.findIndex((t) => t.title === g), [n, s] = _(i), l = (d = e.timelineItems[n]) == null ? void 0 : d.data;
  return b(() => {
    s(i);
  }, [i]), /* @__PURE__ */ f("div", { "data-testid": "timelines-tabs-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ o("div", { className: m["awards-timelines-tabs-scroller"], children: /* @__PURE__ */ o(
      h,
      {
        theme: X,
        layout: D,
        selectedTab: n,
        onTabClick: (t, r) => {
          var c;
          (c = e == null ? void 0 : e.callBack) == null || c.call(e, r), s(t);
        },
        design: tt,
        tabList: a
      }
    ) }),
    /* @__PURE__ */ o("div", { className: m["awards-timelines-container"], children: l == null ? void 0 : l.map((t, r) => /* @__PURE__ */ o(
      C,
      {
        alt_text: t.images[0].alt_text,
        url: t.images[0].image.url,
        description: t.description,
        title: t.title
      },
      `${a[i].id}-${t.title}${t.description}-${r + 1}`
    )) })
  ] });
};
export {
  lt as default
};
//# sourceMappingURL=AwardsAndAccoladesTimelines.js.map
